import * as Action from "@actions/index";

const InitialState = {
  status: "loading",
  data: {},
  error: "",
};

export default function Profile(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Profile.SET_DATA:
      return { ...state, data: action.data };
    case Action.Profile.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Profile.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Profile.CLEAR:
      return { ...state, list: [] };
    default:
      return state;
  }
}
